import React from 'react';
import './HowWeHelp.css';
import background from '../../Assets/background_images/background2.png';

function TrainingAndDevelopment() {
  return (
    <div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
       <img className='image' src={background} alt='training' />
       <div className='heading'> Training and Development </div>
    </div>

    <div> 
      <h1 className='title'>Training and development-get the most out of your team </h1> 
      <p className='paragraph'>
      To build the best team, it's important to know the strengths and  gaps of your employees. By investing in  employee development, you can increase employee engagement, productivity and satisfaction, and enable them to value and achieve results. 
      </p>

      <p className='paragraph'>Use Strategic Link's personalized development and coaching tips: </p>

      <ul className='outer-list'>
        <li> Promotions and Successor Development </li>
        <li> Redistribution of roles during restructuring </li>
        <li> Management identification of likely employees </li>
        <li> Professional development based on the self-confidence of employees </li>
        <li>Coaching insights to help  leaders become more effective in their teams </li>
      </ul>
    </div> 
    <hr />

    <div> 
      <h1 className='title'> How Strategic Links can help: </h1> 
      
      <ul className='outer-list'>
        <li>Candidates can easily extend their development workflow by completing most  assessments on any device within 10 minutes. </li>
        <li>Generate team and group analysis to identify patterns and trends in which personality traits lead to success in different areas of the company. </li>
        <li>The report contains personalized coaching and development tips  to help  support the potential strengths and areas of development. </li>
        <li>Our subscription includes attendee reports and workbooks to help employees become self-conscious and understand how who they are is affecting their engagement at work.</li>
        <li> Increase loyalty and engagement. Employees who fit the ideal job description have been found to stay at work four times longer. This improves productivity and stability, while saving you high training costs due to the high volatility.</li>
      </ul>
    </div> 
    </div>
  );
}

export default TrainingAndDevelopment;